export const SET_SITE = 'SET_SITE';
export const SET_LANG = 'SET_LANG';
export const SET_DELETED_IMAGE = 'SET_DELETED_IMAGE';
export const RESET_DELETED_IMAGES = 'RESET_DELETED_IMAGES';
export const RELOAD_LIST_WITH_PAGINATION = 'RELOAD_LIST_WITH_PAGINATION';
export const SET_FORM = 'SET_FORM';
